<template>
  <v-checkbox
  v-bind="$attrs"
    v-model="internalValue"
    :label="label"
    :off-icon="'$roundedsquare'"
    :on-icon="'$roundedsquarechecked'"
    > 
    
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot"/>

    <!-- Pass on all scoped slots -->
    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope"><slot :name="slot" v-bind="scope"/></template>
  </v-checkbox>
</template>

<script>
import { VCheckbox } from 'vuetify/lib'
export default {
  name: 'CheckBox',
  components: {
    VCheckbox
  },
  props: {
    value: {
    },
    label: {
      type: String,
      default: 'Label'
    },
  },
  watch: {
    internalValue(newValue) {
      this.$emit('input', newValue)
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.internalValue = newValue
      }
    }
  },
  data() {
    return {
      internalValue: ''
    }
  }
}
</script>